/**
 * 右栏示例大预览的 poster 宽度。页面（服务端组件）preload 同一个地址，所以放在不带 "use client" 的文件里：
 * 服务端组件从客户端模块取常量拿到的是引用，不是值
 */
export const EFFECT_EXAMPLE_POSTER_WIDTH = 1080;
